import { SearchProps } from '~components/form-fields/search';

import { SahClaimStatus, SahService } from '~lookups/models';

import { selectLookupClients } from '~main/selectors/clients/clients';

export const searchFields = (claimStatuses: SahClaimStatus[], sahServices: SahService[]): SearchProps => ({
  status_tag: {
    defaultShow: true,
    type: 'multi-lookup',
    field: 'status_tag',
    caption: 'Status',
    placeholder: 'Select...',
    options: claimStatuses.map(({ tag, name }) => ({ id: tag, name })),
  },
  service_date: {
    defaultShow: true,
    type: 'date-range',
    field: 'service_date',
    caption: 'Service Date',
  },
  client_id: {
    defaultShow: true,
    type: 'multi-lookup',
    field: 'client_id',
    caption: 'Client',
    placeholder: 'Select...',
    selectorOptions: selectLookupClients,
  },
  reference: {
    defaultShow: true,
    type: 'text-like',
    field: 'reference',
    caption: 'Ref.',
    placeholder: 'Reference...',
  },
  sah_service_type: {
    defaultShow: true,
    type: 'multi-lookup',
    field: 'sah_service_id',
    caption: 'SAH Service Type',
    placeholder: 'Select...',
    options: sahServices,
  },
});
